export default __webpack_public_path__ + "static/media/check-icon.3f55acfd.svg";